export enum Client {
  ACADEMIA_PLASENCIA = 'academiaplasencia',
  ACADEMYAP = 'academyaplatam',
  ACOSTAVERDE = 'acostaverde',
  ALGOMAS = 'algomas',
  ALQUIMIA = 'universidadalquimia',
  ALTESA = 'capacitacionaltesa',
  ANDREA = 'desarrollandogente',
  APELSA = 'apelsa',
  APPLE = 'apple',
  APRENDIENDO_CON_PRIME = 'aprendiendoconprime',
  ARIZLU = 'arizlu',
  ATRIA = 'atrialogistica',
  AULAVIRTUAL = 'aulavirtual',
  AVANTEX = 'avantex',
  AXIOMA = 'axioma',
  BANNER = 'banner',
  BEREL = 'capacitacionberel',
  BEETMANN = 'beetmann',
  BIDGROUP = 'campusbid',
  BLASCOL = 'blacsol',
  BLK = 'blk',
  BLU_CAPITAL = 'bluniversity',
  BLUNIVERSITY = 'bluniversity',
  CAMPUSALFA = 'campusalfa',
  CAMPUSVERDEVERDAD = 'campusdeverdad',
  CANACO = 'cdccanaco',
  CASALEY = 'casaley',
  CASAEXPRESS = 'tucasaexpress',
  CASSAVA_DOJO = 'cassavadojo',
  CBX = 'ucbx',
  CDG = 'cdg',
  CENTROVIRTUALFA = 'centrovirtualfa',
  CFC = 'cfc',
  CIO = 'cio',
  CLEBER = 'grupocleber',
  CONAUTO = 'academiaconauto',
  CONSTRURAMA = 'uc',
  CORONA_INMMIBILIARIA = 'corona-inmobiliaria',
  CRECEMOS = 'crecemos-contactoenmedios',
  CYBERSEC = 'cybersec',
  DAIKIN = 'universidaddaikin',
  DEACERO = 'universidadeacero',
  DEMO = 'demo',
  DESARROLLOGENI = 'desarrollogeni',
  DESEMPENOSUNSHINE = 'desempenosunshine',
  DIGITALACADEMY = 'digitalacademy',
  EMPRESA = 'empresa',
  EMPRESATLG = 'empresatlg',
  ENERGIZER = 'energizer',
  ENLIGHT = 'enlight',
  ENTRENANDOTEPALIG = 'entrenandotepalig',
  EPESA = 'universidadepesa',
  ESCUELA_PLATA = 'escuelaplata',
  EVALUAR_ACADEMY = 'evaluaracademy',
  EVALUAR_CORPAC = 'corpac-evaluar',
  EVALUAR_STG = 'evaluar',
  EVALUAR_GIM = 'gim-evaluar',
  EVALUAR_INDUBAN = 'induban-evaluar',
  EXCEL = 'excel',
  EXECON = 'universidadexecon',
  EZI = 'universidadezi',
  FAMELEARNING = 'famelearning',
  FERBEL = 'ferbel',
  FEVISA = 'academiafevisa',
  FORMACIONCLASS = 'formacionclass',
  FOUR_PEOPLE = '4people',
  FTECH = 'ftech',
  GAYOSSO = 'gayosso',
  GESTIONDETALENTOGDN = 'gestiondeltalentogdn',
  GESTIONTHEVALUAR = 'gestionthevaluar',
  GONHER = 'gonher',
  GRUPO_ANREA = 'universidadgrupoandrea',
  GRUPO_ANREA_DESAROLLANDO = 'desarrollandogente',
  GRUPO_MARROQUIN = 'grupomarroquin',
  GRUPO_PLAZA = 'grupoplaza',
  GRUPO_PETRO = 'grupopetro',
  GRUPOMC = 'grupomc',
  GTRIMEX = 'gtrimex',
  HCM = 'gestiondetalentohcm',
  HEMA = 'talentohema',
  HILCO = 'hilcouniversity',
  HIRCASA = 'universidadhircasa',
  HORTIFRUT = 'tecnologico-hortifrut',
  IAC = 'desarrolloiac',
  INDELPRO = 'indelpro',
  ILUMINATIONMEGAMEX = 'iluminacionmegamex',
  IMPULSATE = 'impulsate',
  INTEGRA = 'integratudesarrollo',
  INTERMEX = 'ucintermex',
  IRRAZONABLES = 'jovenescompartamos',
  JAFRA = 'jafra',
  JAFRA_EVALUAR = 'jfmx-evaluar',
  JUMBO = 'jumbouniversity',
  KAO = 'grupokao',
  KIKES = 'universidadkikes',
  KONICAMINOLTA = 'konicaminoltalearning',
  KONTA = 'konta',
  KREDI = 'kredi',
  KUBOTA = 'elearningkubota',
  LAPZOMIEDUCACION = 'walmart-lapzo',
  LERNIT = 'lernit',
  LUXUN = 'luxunacademy',
  MAGIC = 'magic',
  MAGUENGROUP = 'maguengroup',
  MAZDA = 'mazda',
  MEDDI = 'universidadmeddi',
  MELONN = 'melonn',
  MIEDUCACIONWALMART = 'mieducacionwalmart',
  MIAA = 'desarrollodetalento',
  MITINFRA = 'academiamitinfra',
  MULTIPROSEG = 'academia-grupomultiproseg',
  NESTLE = 'programaemprendedor',
  OBJETIVOS = 'objetivos',
  OMEXALIMENTARIA = 'universidadomexalimentaria',
  OMNIBUSDEMEXICO = 'omnibusdemexico',
  OMNICRON_LAB = 'omnicronlab',
  ONECARD = 'onecard',
  OVERNIA_ZANEO = 'overnia-zaneo',
  PENARANDA = 'campuspenaranda',
  PEPSICO = 'skillcompassbysolutions',
  PLATAFORMABEDU = 'plataformabedu',
  PLATAFORMABEDU_SANTANDER = 'plataformasantander-bedu',
  PROAMBI = 'universidadproambi',
  PRUEBASQA = 'pruebasqa',
  PUNTOUNOLAB = 'puntounolab',
  QREANDOTUDESARROLLO = 'qreandotudesarrollo',
  REDPACK = 'redpack',
  RENDILITROS = 'gestiondetalentorendilitros',
  ROTOPLAS = 'rotoplas',
  SANCAYETANO = 'sancayetano',
  SANJACINTO = 'sanjacinto',
  SENDENGO = 'sendengo',
  SHOGUA = 'gestiondetalentoshogua',
  SKYDROPX = 'skydropx',
  SKYWAY = 'midesarrolloskyway',
  SNSMEDICALSOLUTIONS = 'smsmedicalsolutionseducation',
  SOLINTEGRA = 'solintegra',
  SOUTHBAY = 'southbay',
  SOY_NETO = 'soyneto',
  SQA = 'sqa',
  SUMITOMO = 'universidadsumitomo',
  SUPRALUX = 'academiasupralux',
  SWARTZ = 'universidadswartz',
  SWISSJUST = 'induccionjust',
  TALENTOHOS = 'talenthos',
  TALENTOURBANO = 'talentourbano',
  TATA = 'gestiondeltalentotata',
  TEAM = 'team',
  TECMILENIO = 'tecmilenio',
  TECMILENIOIMAGEN = 'skillingcenterimagen',
  TET = 'tet',
  TETAKAWI = 'tetakawi',
  TRACKINN = 'trackinn',
  TRENING = 'trening',
  TRIVAS = 'trivasaymacizo',
  TUEMPRESA = 'tuempresa',
  TUPLATAFORMA = 'tuplataforma',
  UCAFE_PUNTA = 'ucafepuntadelcielo',
  UESFUEL = 'gestiondeltalentouesfuel',
  UNI_CORPORATIVA_UES_FUEL = 'universidadcorporativauesfuel',
  UNICCO = 'grupounicco',
  UNILAR = 'unilar',
  UNIVERSIDAD_ABX = 'universidadabx',
  UNIVERSIDAD_BUPA = 'universidadbupa',
  UNIVERSIDAD_HOMELIVING = 'universidadhomesandliving',
  UNIVERSIDAD_IBC = 'universidadibc',
  UNIVERSIDADCONFIA = 'universidadconfia',
  UNIVERSIDADGCP = 'universidadgcp',
  UNIVERSIDADGP = 'universidadgp',
  UNIVERSIDADLAHAUS = 'lahaus',
  UNIVERSIDADMRM = 'universidadmrm',
  UNIVERSIDADPOTOSI = 'universidadelpotosi',
  UNIVERSIDADTEPEYAC = 'universidadgrupotepeyac',
  WALMARTEDUCACIONTECMILENIO = 'mieducacionwalmart',
  WELLDEX = 'welldex',
  ZAPATA = 'zapata',
  S4UNI = 's4uni',
  TALENTOLINKO = 'talentolinko',
  INSTITUTOCOSMIC = 'institutocosmic'
}

export enum User {
  COLLABORATOR = 'P',
  LEADER = 'I',
  ADMIN = 'A',
  LITE = 'L',
  EXTERNAL = 'E',
  BOSS = 'BOSS', // Not a user type, but a flag to indicate that the user is a boss
}

export enum Modules {
  COMPASS = 'compass',
  LEARNING = 'learning',
  COMMUNITY = 'community',
  PERFORMANCE = 'performance',
  COMPETENCIES = 'competencies',
  PID = 'pid',
  EVALUATIONS = 'evaluations',
  JOBS = 'jobs',
  DIAGNOSES = 'diagnoses',
  TEMPLATE = 'template',
  STPS = 'stps',
  OBJECTIVES = 'objectives',
  CERTIFIERS = 'certifiers',
  CLIMATE = 'climate',
  GAMIFICATION = 'gamification',
  STRATEGIES = 'strategies',
  COURSES_EXPRESS = 'coursesExpress',
}

export enum ResourceType {
  LP = 'Learning Path',
  DG = 'Course Degree',
  SM = 'Course Blended',
  OL = 'Course Online',
  OS = 'Course Presential',
  RG = 'Course Register',
  A = 'SCORM',
  E = 'Evaluation',
  S = 'Quizz',
  V = 'Video',
  L = 'Lecture',
  F = 'Forum',
  T = 'Task',
  M = 'Meeting',
}

export enum SortOrder {
  ASC = 'asc',
  DESC = 'desc',
}

export enum ResourceTypeKardex {
  LEARNING_PATH = 'LP',
  COURSE_ONLINE = 'OL',
  COURSE_REGISTER = 'RG',
}

export enum ReaccreditationStatusEnum {
  ACTIVE = 'ACTIVE',
  EXPIRED = 'EXPIRED',
  INACTIVE = 'INACTIVE',
}
